/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import { ValidationErrorFieldsFragmentDoc } from '../../../context/Customer/GraphQL/ForgotPassword.generated';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type OrderHistoryQueryVariables = Types.Exact<{
  input: Types.OrdersInput;
}>;

export type OrderHistoryQuery = {
  readonly __typename?: 'Query';
  readonly orders:
    | {
        readonly __typename: 'OrdersResponseSuccess';
        readonly pagination: {
          readonly __typename?: 'Pagination';
          readonly total: number;
        };
        readonly orders: ReadonlyArray<{
          readonly __typename?: 'Order';
          readonly id: string;
          readonly orderType: Types.OrderType;
          readonly wantedTime: string;
          readonly description: string;
          readonly total: number | null;
          readonly canCancel: boolean;
          readonly lineItems: ReadonlyArray<{
            readonly __typename?: 'LineItem';
            readonly id: string;
            readonly customName: string | null;
            readonly isCustom: boolean;
            readonly product: {
              readonly __typename?: 'Product';
              readonly id: string;
              readonly name: string;
              readonly isCustom: boolean;
              readonly categoryName: string;
            };
          }>;
          readonly asset: {
            readonly __typename?: 'Asset';
            readonly url: string;
          };
          readonly restaurant: {
            readonly __typename?: 'Restaurant';
            readonly id: string;
            readonly name: string;
            readonly isOutpost: boolean;
          };
          readonly deliveryOrderDetail: {
            readonly __typename?: 'DeliveryOrderDetail';
            readonly id: string;
            readonly address: {
              readonly __typename?: 'Address';
              readonly id: string;
              readonly name: string | null;
            };
          } | null;
        }>;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export const orderHistoryQueryMock: ExecutionResult<OrderHistoryQuery> = {
  data: {
    orders: {
      __typename: 'OrdersResponseSuccess',
      pagination: { total: 84 },
      orders: [
        {
          id: '09e6ea9f-ee42-4a99-a258-7ce71904308d',
          orderType: 'DELIVERY',
          wantedTime: 'Hello World',
          description: 'Hello World',
          total: 38,
          canCancel: false,
          lineItems: [
            {
              id: '7163ba7e-da96-4e8a-985e-3da00a9a4753',
              customName: 'Hello World',
              isCustom: false,
              product: {
                id: '319d0806-0b59-4aa2-90f9-c4016b1bd634',
                name: 'Hello World',
                isCustom: true,
                categoryName: 'Hello World',
              },
            },
            {
              id: 'b273b7f9-f18d-4030-b1b1-f2c49f5fd799',
              customName: 'Hello World',
              isCustom: false,
              product: {
                id: 'ccdcab38-b748-45af-be88-532ede7a1daa',
                name: 'Hello World',
                isCustom: true,
                categoryName: 'Hello World',
              },
            },
          ],
          asset: { url: 'Hello World' },
          restaurant: {
            id: '33e0e095-a7b4-48f0-bb56-0d0180d39ca0',
            name: 'Hello World',
            isOutpost: true,
          },
          deliveryOrderDetail: {
            id: '0520a352-a4a6-4541-b5bc-5d089f52e921',
            address: {
              id: 'd91bfdfb-abd3-48fd-b8eb-150587b384c4',
              name: 'Hello World',
            },
          },
        },
        {
          id: '8299be51-1f9b-41e3-9b6d-74afbe52f8a3',
          orderType: 'DELIVERY',
          wantedTime: 'Hello World',
          description: 'Hello World',
          total: 26,
          canCancel: false,
          lineItems: [
            {
              id: '32f0edae-f122-4810-af29-1521b27f2bad',
              customName: 'Hello World',
              isCustom: true,
              product: {
                id: '9c8f96f0-10ca-4153-9642-9788b394138d',
                name: 'Hello World',
                isCustom: false,
                categoryName: 'Hello World',
              },
            },
            {
              id: '004934e0-80ad-47fd-a251-4dd94f36b41c',
              customName: 'Hello World',
              isCustom: false,
              product: {
                id: '3d4c4b96-caa8-4622-a517-d3cbc3f05167',
                name: 'Hello World',
                isCustom: true,
                categoryName: 'Hello World',
              },
            },
            {
              id: '358d451b-9313-4663-9b9e-b2f517f534a2',
              customName: 'Hello World',
              isCustom: false,
              product: {
                id: 'f5acfbda-03bf-4af7-a27a-59a381e64855',
                name: 'Hello World',
                isCustom: true,
                categoryName: 'Hello World',
              },
            },
          ],
          asset: { url: 'Hello World' },
          restaurant: {
            id: 'e3c2470d-5f38-4aff-a742-2c62933169f0',
            name: 'Hello World',
            isOutpost: true,
          },
          deliveryOrderDetail: {
            id: 'ff6a9347-d88d-48ee-a30f-22b944d253ab',
            address: {
              id: '94c40130-7664-4c55-b9f5-16095e6ededc',
              name: 'Hello World',
            },
          },
        },
      ],
    },
  },
};

export const OrderHistoryDocument = gql`
  query orderHistory($input: OrdersInput!) {
    orders(input: $input) {
      __typename
      ... on OrdersResponseSuccess {
        pagination {
          total
        }
        orders {
          id
          orderType
          wantedTime
          description
          total
          canCancel
          lineItems {
            id
            customName
            isCustom
            product {
              id
              name
              isCustom
              categoryName
            }
          }
          asset {
            url
          }
          restaurant {
            id
            name
            isOutpost
          }
          deliveryOrderDetail {
            id
            address {
              id
              name
            }
          }
        }
      }
      ...ValidationErrorFields
    }
  }
  ${ValidationErrorFieldsFragmentDoc}
`;

export function useOrderHistoryQuery(
  options: Omit<Urql.UseQueryArgs<OrderHistoryQueryVariables>, 'query'>,
) {
  return Urql.useQuery<OrderHistoryQuery, OrderHistoryQueryVariables>({
    query: OrderHistoryDocument,
    ...options,
  });
}
